/* eslint-disable no-use-before-define */
import { useState } from 'react'

import type { PayPalButtonsComponentProps } from '@paypal/react-paypal-js'
import { usePayPalScriptReducer } from '@paypal/react-paypal-js'
import { useRouter } from 'next/router'

import {  PAYMENT_GATWAY, TUCKERTUB_AUTH_TOKEN, WOOCOMMERCE_TUCKERTUB_ORDER } from '~/constants'
import { useAuth, useCart, useGlobalState, useOrder } from '~/context'
import { useGetCartQuery } from '~/graphql/__generated__'
import { getFloatVal } from '~/libv2/getFloatVal'
import Cookies from "js-cookie";


// Amount needs to be the same as the lineItems, but how do we pass the taxes from WooCommerce then?

export const usePaypal = () => {
  const { data: cartData } = useGetCartQuery()
  const { abortController } = useCart()
  const { shippingMethod } = useOrder()
  const { user } = useAuth()
  const router = useRouter()
  const [{ options }] = usePayPalScriptReducer()
  const { openFullScreenModal,closeFullScreenModal  } = useGlobalState()

  const [errorMessage, setErrorMessage] = useState('')
  const foundOrder = localStorage.getItem(WOOCOMMERCE_TUCKERTUB_ORDER)
  const parsedOrder = JSON.parse(foundOrder ?? '{}')

    

  const amount = getFloatVal(cartData?.cart?.discountTotal || "0") > 0 ? parseFloat( getFloatVal( cartData.cart?.subtotal || '0') + getFloatVal( cartData.cart?.subtotalTax || '0') ) - ( getFloatVal( cartData.cart?.discountTotal || '0')  + getFloatVal( cartData.cart?.discountTax || '0') ).toFixed(2)  :  parseFloat(getFloatVal( cartData.cart?.subtotal || '0') +  getFloatVal( cartData.cart?.subtotalTax || '0')).toFixed(2)
  //console.log('PayPalTotalCartAmount', amount)

  const handlePaypalCreateOrder = async (
    data:any,
    actions:any,
    order:any
  ) => {
    // console.log('parsedOrderPAYPAL', parsedOrder)
    try {
      const lineItems = (cartData?.cart?.contents?.nodes || []).map(item => ({
        name: item?.variation?.node?.name || '',
        quantity: item?.quantity?.toString() || '0',
        unit_amount: {
          currency_code: options.currency,
          value: getFloatVal(item?.variation?.node?.price || '0').toString()
        }
      }))

      if (!order?.shipping_lines?.[0].total) {
        handleOnCancel()
        return 'cancel'
      }

      const firstShippingLine = order?.shipping_lines[0].total
      const shippingValue = getFloatVal(firstShippingLine || '0')
      const itemTotal = getFloatVal(String(amount))
      const totalValue = (itemTotal + shippingValue).toFixed(2)

      const shippingData = {
        address: {
          address_line_1: order.shipping.address_1,
          address_line_2: order.shipping.address_2,
          admin_area_1: order.shipping.state,
          admin_area_2: order.shipping.city,
          postal_code: order.shipping.postcode,
          country_code: 'AU'
        },
        email_address: order.email,
        phone_number: {
          national_number: order.shipping.phone
        },
        name: {
          full_name: `${order.shipping.first_name} ${order.shipping.last_name}`
        },
        options: [
          {
            id: shippingMethod.id,
            label: shippingMethod.title,
            type: 'SHIPPING',
            selected: true,
            amount: {
              currency_code: options.currency,
              value: firstShippingLine.toString() ?? '0'
            }
          }
        ]
      }

      // console.log('shipingData', shippingData)
      // console.log('shippingMethodvvvvvvv', shippingMethod)

      const createdOrder = await actions.order.create({
        purchase_units: [
          {
            amount: {
              currency_code: options.currency,
              value: totalValue,
              breakdown: {
                item_total: {
                  currency_code: options.currency ?? 'AUD',
                  value: itemTotal.toFixed(2)
                },
                shipping: {
                  currency_code: options.currency ?? 'AUD',
                  value: shippingValue.toFixed(2)
                }
              }
            },
            custom_id: order.id,
            // items: lineItems,
            shipping: shippingData
            // invoice_id: data.invoice_id
          }
        ]
        // payer: {

        // }
      })
      //console.log('createdOrder paypal', createdOrder)

      return createdOrder

      // return router.push(
      //   `${process.env.NEXT_PUBLIC_FRONTEND_URL}/confirmation?paypalOrderId=${createdOrder}`
      // )
    } catch (error) {
      // console.log('PaypalButtonCreateOrder error', error)
      setErrorMessage(error.message)
      return 'error'
    }
  }

  async function handleApproveOrder(order: any) {
    openFullScreenModal()
    try {
      // console.log('handleApproveOrderOrder', order)

      if (order.status !== 'COMPLETED') {
        closeFullScreenModal()
        throw new Error('Order not completed')
      }

      const wooCommerceOrderId = order.purchase_units?.[0].custom_id

      const updatedOrderInput = {
        payment_method: 'paypal',
        payment_method_title: 'PayPal',
        status: 'processing'
      }
      const accessToken = Cookies.get(TUCKERTUB_AUTH_TOKEN)
      const isGuestCheckout = !accessToken 

      // const response = await fetch(
      //   `${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/commerce/orders/update-order`,
      //   {
      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json'
      //     },
      //     signal: abortController?.signal,
      //     body: JSON.stringify({
      //       orderId: wooCommerceOrderId,
      //       orderInput: updatedOrderInput,
      //       orderEmail: user?.email ?? parsedOrder.email,
      //       isGuestCheckout,
      //       accessToken:accessToken || '' 
      //     })
      //   }
      // )

      // if( response.status === 401 ){
      //   Cookies.remove(TUCKERTUB_AUTH_TOKEN);
      //   window.location.replace('/account');
      // }

      // if (!response.ok) {
      //   closeFullScreenModal()
      //   throw new Error('Error updating order')
      // }
      closeFullScreenModal()
      localStorage.setItem(PAYMENT_GATWAY,'paypal')
      return router.push(
        `${process.env.NEXT_PUBLIC_FRONTEND_URL}/confirmation?paypalOrderId=${order.id}`
      )
    } catch (error) {
      closeFullScreenModal()
      //console.log('PaypalButtonHandleApproveOrder error', error)
      setErrorMessage(error.message)
    }
    closeFullScreenModal()
  }

  async function handleOnApprove(data, actions) {
    // console.log('PayPal onApproveData', data)
    // console.log('PayPal onApproveActions', actions)
    try {
      const capturedOrder = await actions.order?.capture()
      // console.log('capturedOrder', capturedOrder)
      await handleApproveOrder(capturedOrder)
    } catch (error) {
      // console.log('PaypalButtonOnApprove error', error)
      setErrorMessage(error.message)
    }
  }

  async function handleOnCancel() {
    // console.log('PayPal onCancel')
  }

  async function handleOnError(err: Record<string, unknown>) {
    //console.log('PayPal onError', err)
    // router.push(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/confirmation`)

    return setErrorMessage(err.message)
  }

  function handleOnShippingChange(data, actions) {
    //console.log("PayPal onShippingChange", data, actions);
    if (data.shipping_address?.country_code !== "AU") {
      //console.log("PayPal onShippingChange Reject");
      return actions.reject();
    }

    // Shipping is already included in amount.value/breakdown.shipping at order
    // creation, so no further amount patching is needed here. Kept below for
    // reference: this used to react to onShippingChange to top up the total,
    // but it replaced the whole `amount` object (wiping out `breakdown`) and
    // recomputed the total from a live re-read of the cart rather than the
    // values actually used when the order was created.
    // if( parseInt(data?.amount?.breakdown?.shipping?.value) === 0  ){
    //   const total = parseFloat(amount) + parseFloat(data?.selected_shipping_option?.amount?.value )
    //   return actions.order.patch([
    //     {
    //       op: "replace",
    //       path: "/purchase_units/@reference_id=='default'/amount",
    //       value: {
    //             currency_code: "AUD",
    //             value: total?.toString(),
    //         },
    //     },
    //   ]);
    // }
    return actions.resolve();
  }

  return {
    handlePaypalCreateOrder,
    handleOnApprove,
    handleOnCancel,
    handleOnError,
    handleOnShippingChange,
    errorMessage
  }
}
